import {RouteRecordRaw} from 'vue-router';

const routes: RouteRecordRaw[] = [
    {
        // 직원 내역
        path: '/member/list',
        name: 'MemberList',
        meta: {
            title: '직원 내역',
        },
        components: {
            default: () => import('@/views/member/MemberList.vue'),
            NavBar: () => import('@/components/common/layout/NavBar.vue'),
            SideBar: () => import('@/components/common/layout/SideBar.vue'),
        },
    },
    {
        // 직원 내역 > 개별 등록
        path: '/member/list/individual-register',
        name: 'MemberIndividualRegister',
        meta: {
            title: '직원 내역 개별 등록',
        },
        components: {
            default: () =>
                import('@/views/member/MemberIndividualRegister.vue'),
            NavBar: () => import('@/components/common/layout/NavBar.vue'),
            SideBar: () => import('@/components/common/layout/SideBar.vue'),
        },
    },
    {
        // 직원 내역 > 일괄 등록
        path: '/member/list/bulk-register',
        name: 'MemberBulkRegister',
        meta: {
            title: '직원 내역 일괄 등록',
        },
        components: {
            default: () => import('@/views/member/MemberBulkRegister.vue'),
            NavBar: () => import('@/components/common/layout/NavBar.vue'),
            SideBar: () => import('@/components/common/layout/SideBar.vue'),
        },
    },
    {
        // 직원 초대
        path: '/member/invitation/:action',
        name: 'MemberInvitation',
        meta: {
            title: '직원 초대',
        },
        components: {
            default: () => import('@/views/member/MemberInvitation.vue'),
            NavBar: () => import('@/components/common/layout/NavBar.vue'),
            SideBar: () => import('@/components/common/layout/SideBar.vue'),
        },
    },
    {
        // 직원 초대
        path: '/member/department',
        name: 'MemberDepartment',
        meta: {
            title: '그룹 관리',
        },
        components: {
            default: () => import('@/views/member/MemberDepartment.vue'),
            NavBar: () => import('@/components/common/layout/NavBar.vue'),
            SideBar: () => import('@/components/common/layout/SideBar.vue'),
        },
    },
];

export default routes;
